const listados = {};

listados.documentTypes = {
  0: "TI - Tarjeta de identidad.",
  1: "CC - Cédula de ciudadanía.",
  2: "CE - Cédula de extranjería.",
  3: "PA - Pasaporte.",
  4: "PEP - Permiso especial de permanencia.",
};

listados.typesOfReports = {
  0: "Inicio",
  1: "Almuerzo",
  2: "Baño",
  3: "Recursos",
  4: "Novedades",
  5: "Avance",
  6: "Finalización",
};

listados.profiles = {
  0: "ANIMADOR",
  1: "ANIMADOR APERT",
  2: "ANIMADOR TIGO",
  3: "ANIMADOR TIGO 1/2",
  4: "BAILARINA 4",
  5: "CONDUCTOR",
  6: "COORDINADOR",
  7: "COORDINADOR 1/2",
  8: "COORDINADOR M",
  9: "COORDINADOR M 1/2",
  10: "DIGITADOR",
  11: "DUMMIE ARA",
  12: "DUMMIE TIGO",
  13: "DUMMIE TIGO 1/2",
  14: "ENTRUZADO",
  15: "ESTATUA",
  16: "LOGISTICO",
  17: "LOGISTICO 1/2",
  18: "LOGISTICO DIG",
  19: "LOGISTICO M",
  20: "PERIFONEO",
  21: "PERSONAJE",
  22: "PINTUCARITA 1/2",
  23: "PINTUCARITA CON MAQ",
  24: "PINTUCARITA SIN MAQ",
  25: "PINTUCARITA TIGO",
  26: "POPMAN",
  27: "PROMOTOR",
  28: "PROMOTOR 1/2",
  29: "PROMOTOR CC",
  30: "PROMOTORA TIGO",
  31: "RECREADOR",
  32: "TELEMERCADEO",
  33: "TVPOPMAN",
  34: "SCOOTER",
  35: "LOGISTICO T",
  36: "REDMAN",
};

listados.coordinators = {
  0: "No",
  1: "Si",
};

export default listados;
